import _ from 'lodash'

export const investorTypeChoices = [
  { label: 'PE Fund', value: 'pe' },
  { label: 'Incubator', value: 'incubator' },
  { label: 'BAN', value: 'ban' },
  { label: 'Accelerator', value: 'accelerator' },
  { label: 'Corporate VC', value: 'corporate_vc' },
  { label: 'BA', value: 'ba' },
  { label: 'VC Fund', value: 'vc_fund' },
]

export const investorTypeChoiceByLabel = _.keyBy(investorTypeChoices, 'label')
export const investorTypeChoiceByValue = _.keyBy(investorTypeChoices, 'value')

export function investorLabel(value) {
  if (!value) {
    return '-'
  }
  const choice = investorTypeChoiceByValue[value]
  if (!choice) {
    throw new Error(`No choice for investor type value: ${value}`)
  }
  return choice.label
}
